import React ,{useState} from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from "flowbite-react";
import SimDetailsModal from "../Modals/SimDetails";

const SimTable = ({ sims }) => {
  const [selectedSim,setSelectedSim] = useState(null);
  const [isSimModalOpen, setIsSimModalOpen] = useState(false);
  const tableCells = [
    "ICCID",
    "IMSI_1",
    "IMSI_2",
    "SN",
    "created_at",
    "status",
  ];

  const handleRowClick = (sim) => {
    setSelectedSim(sim)
    setIsSimModalOpen(true)
  }

  const toggleModale= () => {
    setIsSimModalOpen(!isSimModalOpen)
  }
  return (
    <>
    <div className="overflow-x-auto">
      {sims?.length > 0 ? (
        <Table className="dark:bg-gray-800">
          <TableHead>
            {tableCells.map((feild, index) => {
              return <TableHeadCell key={index}>{feild}</TableHeadCell>;
            })}
          
          </TableHead>
          <TableBody className="divide-y dark:bg-gray-500 ">
            {sims?.map((simInfo, index) => {
              return (
                <TableRow
                    onClick={() => handleRowClick(simInfo.SN)}
                  key={index}
                  className="bg-white  dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
                  <TableCell className="font-bold">{simInfo?.ICCID}</TableCell>
                  <TableCell className="text-blue-900">
                    {simInfo?.IMSI_1}
                  </TableCell>
                  <TableCell className="">{simInfo?.IMSI_2}</TableCell>
                  <TableCell>{simInfo?.SN}</TableCell>
                  <TableCell>
                    <span
                      className={`px-2 py-1 rounded-full text-white text-sm ${
                        simInfo?.status === "preactive"
                          ? "bg-blue-500"
                          : simInfo?.status === "active"
                          ? "bg-green-500"
                          : "bg-gray-500"
                      }`}>
                      {simInfo?.status}
                    </span>
                  </TableCell>
                  <TableCell>{simInfo?.created_at?.slice(0, 10)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <div className="p-2">Aucune Carte sims trouvé</div>
      )}
    </div>
    <SimDetailsModal sim={selectedSim} isOpen={isSimModalOpen} setIsopen={toggleModale}></SimDetailsModal>
    </>
  );
};

export default SimTable;
